import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import SchedulingConfiguration from '@/types/table/schedulingConfiguration';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface SchedulingConfigurationData extends SchedulingConfiguration {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class SchedulingConfigurationController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<SchedulingConfigurationData>>(API_CONTEXT + '/app/schedulingConfiguration/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<SchedulingConfigurationData>(API_CONTEXT + '/app/schedulingConfiguration/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/schedulingConfiguration/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/schedulingConfiguration/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/schedulingConfiguration/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingConfiguration/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingConfiguration/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingConfiguration/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingConfiguration/deleteBatch', params, httpOptions);
  }

  static selectByListYearmonth(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingConfiguration/selectByListYearmonth', params, httpOptions);
  }

  static getStatus(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/schedulingConfiguration/getStatus', params, httpOptions);
  }
}
